var _path, _path2, _mask, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0625 10.3135L12 14.25L15.9375 10.3135",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.75V14.2472",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_2_251",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 14.25V19.5C20.25 19.6989 20.171 19.8897 20.0303 20.0303C19.8897 20.171 19.6989 20.25 19.5 20.25H4.5C4.30109 20.25 4.11032 20.171 3.96967 20.0303C3.82902 19.8897 3.75 19.6989 3.75 19.5V14.25"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.65 14.25C21.65 13.4768 21.0232 12.85 20.25 12.85C19.4768 12.85 18.85 13.4768 18.85 14.25H21.65ZM5.15 14.25C5.15 13.4768 4.5232 12.85 3.75 12.85C2.9768 12.85 2.35 13.4768 2.35 14.25H5.15ZM18.85 14.25V19.5H21.65V14.25H18.85ZM18.85 19.5C18.85 19.3276 18.9185 19.1623 19.0404 19.0404L21.0203 21.0203C21.4235 20.6171 21.65 20.0702 21.65 19.5H18.85ZM19.0404 19.0404C19.1623 18.9185 19.3276 18.85 19.5 18.85V21.65C20.0702 21.65 20.6171 21.4235 21.0203 21.0203L19.0404 19.0404ZM19.5 18.85H4.5V21.65H19.5V18.85ZM4.5 18.85C4.67239 18.85 4.83772 18.9185 4.95962 19.0404L2.97972 21.0203C3.38293 21.4235 3.92979 21.65 4.5 21.65V18.85ZM4.95962 19.0404C5.08152 19.1623 5.15 19.3276 5.15 19.5H2.35C2.35 20.0702 2.57652 20.6171 2.97972 21.0203L4.95962 19.0404ZM5.15 19.5V14.25H2.35V19.5H5.15Z",
    fill: "#333333",
    mask: "url(#path-3-inside-1_2_251)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.7f989eed.svg";
export { ForwardRef as ReactComponent };